//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

import { boundClass } from 'autobind-decorator';
import { AxiosInstance, AxiosResponse, AxiosRequestConfig } from 'axios';
import { encodeUrlParameter, getAxiosData } from '../../../common/urlUtility';
@boundClass export class PriceSyncController
{
  
  private readonly axios: AxiosInstance
  
  constructor (axios: AxiosInstance)
  {
    this.axios = axios
  }
  enablePriceSyncOzon(ozonAccountId: number, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`PriceSync/EnablePriceSyncOzon/${encodeUrlParameter(ozonAccountId)}`, null, _config).then(getAxiosData)
  }
  

  enablePriceSyncWb(wbAccountId: number, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`PriceSync/EnablePriceSyncWb/${encodeUrlParameter(wbAccountId)}`, null, _config).then(getAxiosData)
  }
  

  enablePriceSyncYandexMarket(yandexMarketAccountId: number, _config?: AxiosRequestConfig) : Promise<void>
  {
    return this.axios.post<void>(`PriceSync/EnablePriceSyncYandexMarket/${encodeUrlParameter(yandexMarketAccountId)}`, null, _config).then(getAxiosData)
  }
  

}
